import axios from "axios";
import * as sessionActions from "../../redux/actions/sessionActions";
import { getStore } from "../../redux/configureStore/configureStore";
import { extractRefreshToken, getAccessToken, getSession, updateAccessToken } from "./tokenStorage";



export const configureBaseUrl = (baseUrl = "/protected") => axios.defaults.baseURL = baseUrl;

export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

const endExpiredSession = (store) => {
  if (store) store.dispatch(sessionActions.logout());
  if (window.location.pathname !== '/cp/login') {
    window.location.replace('/cp/login');
  }
};

export const setAuthInterceptor = () => {
  let refreshPromise = null;
  axios.interceptors.request.use( async request => {
    if (request.skipAuthRefresh) return request;

    const decodedUser = getSession();
    if (decodedUser){
      const currentTime = Date.now() / 1000;
      if (decodedUser.exp < currentTime){
        try {
          if (!refreshPromise) {
            refreshPromise = refreshToken()
              .then(async response => {
                const data = response.data;
                const token = extractRefreshToken(data);
                if (!data.status || !token) {
                  throw new Error('Session refresh was rejected.');
                }

                const updatedSession = await updateAccessToken(token);
                setAuthToken(updatedSession.token);
                const currentStore = getStore();
                if (currentStore) {
                  currentStore.dispatch(sessionActions.receiveCurrentUser(updatedSession));
                }
                return updatedSession;
              })
              .catch(error => {
                endExpiredSession(getStore());
                throw error;
              })
              .finally(() => {
                refreshPromise = null;
              });
          }
          const updatedSession = await refreshPromise;
          request.headers = request.headers || {};
          request.headers.Authorization = `Bearer ${updatedSession.token}`;
          return request;
        } catch (e) {
          return Promise.reject(e);
        }
        
      } else {
        return request;
      }
    } else {
      return request;
    }
    
  })
}

;


// Boot awaits this call before rendering anything, and axios has no default
// timeout, so a refresh endpoint that accepts the connection and never answers
// would leave a blank page indefinitely. Time it out instead: the rejection
// runs the normal expired-session path and the user lands on the login page.
const REFRESH_TIMEOUT_MS = 15000;

export const refreshToken = () => {
  const axiosRefresh = axios.create({
    baseUrl: "/protected",
  });
  const token = getAccessToken();
  if (!token) return Promise.reject(new Error('Cannot refresh without an access token.'));
  axiosRefresh.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  return axiosRefresh.get("/api/v1/jwt/refresh", { timeout: REFRESH_TIMEOUT_MS });
}

const unauthenticatedRequest = { skipAuthRefresh: true };

export const login = user => axios.post("/users/authenticate-portal-user", user, unauthenticatedRequest);
export const forgotPassword = user => axios.post("/users/forgot-portal-user-password", user, unauthenticatedRequest);
export const validateTokenApi = tokenArray => axios.post("/users/validate-portal-user-reset-password-token", tokenArray, unauthenticatedRequest);
export const resetPassword = data => axios.post("/users/reset-portal-user-password", data, unauthenticatedRequest);
export const loginBytoken = token => axios.post("/users/authenticate-portal-user-by-cp-token", token, unauthenticatedRequest);
export const fetchFieldSettings = filter => {
  return axios.post(`/api/v1/orders/fields`, filter)
}
export const settings = () => axios.get("/customerportal/settings");
